import { styled } from '@mui/system';

export const TableCellStyles = {
    padding: '10px 12px',
    border: '1px solid #B9B9B9',
};

export const TableHeaderCellStyles = {
    padding: '10px 12px',
    border: '1px solid #B9B9B9',
};

export const CellText = styled('h3')(({ theme }) => ({
    fontWeight: '700',
    margin: '5px 0px',
    [theme.breakpoints.up('sm')]: {
        fontSize: '1.2rem',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
    },
}));

export const StyledTableContainer = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        margin: '0px 50px',
    },
    [theme.breakpoints.down('sm')]: {
        margin: '0px',
    },
}));
